import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const listOrdersStyles = makeStyles((theme: Theme) =>
    createStyles({
        title: {
            fontFamily: 'Cormorant Garamond',
            fontStyle: 'italic',
            fontWeight: 600,
            fontSize: '3.5rem',
            textAlign: 'center',
            [theme.breakpoints.down('md')]: {
                fontSize: '2rem'
            }
        },
        pagination: {
            display: 'flex',
            justifyContent: 'center',
            margin: '30px 0px 30px 0px',
            '& .MuiPaginationItem-textSecondary.Mui-selected': {
                backgroundColor: '#D32F2F'
            }
        }
    })
);

export default listOrdersStyles;
